import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BellNotificationsContentComponent } from './page/bell-notifications-content/bell-notifications-content.component';
import { BellNotificationsComponent } from './page/bell-notifications/bell-notifications.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children:[
      {
        path: 'BellNotifications',
        component: BellNotificationsComponent
      },
      {
        path: 'BellNotificationsContent',
        component: BellNotificationsContentComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationsRoutingModule { }
